// Quick Add to Cart functionality
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".quick-add__size-btn--disabled");

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const isMobile = window.innerWidth <= 700;
    const quickAddContainer = btn.closest(".product-card__quick-add");
    if (isMobile || quickAddContainer.dataset.discontinued === "true") {
      return;
    }

    // --- Desktop: show popup ---
    const bisPopup = document.querySelector("cl-klaviyo-bis-popup");
    if (!bisPopup) {
      console.warn("BIS popup not found");
      return;
    }

    bisPopup.setAttribute("variant-id", btn.dataset.variantId || "");
    bisPopup.setAttribute("product-id", btn.dataset.productId || "");
    bisPopup.setAttribute("product-title", btn.dataset.productTitle || "");
    bisPopup.setAttribute("product-image", btn.dataset.productImage || "");
    bisPopup.setAttribute("variant-title", btn.dataset.variantTitle || "");

    bisPopup.toggle(true);
  });

  // Function to handle quick add to cart
  function addToCartQuick(variantId, productTitle, size, button) {
    const originalText = button.textContent;

    // Add loading state
    button.classList.add("loading");
    button.classList.add("is-loading");

    // Prepare the data for the cart API - using FormData like the theme does
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    // Get sections to bundle for cart updates
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    if (sectionsToBundle.length > 0) {
      formData.append("sections", sectionsToBundle.join(","));
    }

    // Start theme loading
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(async (responseJson) => {
        // Success feedback
        button.textContent = "✓";
        // button.style.background = "#10B981";
        // button.style.borderColor = "#10B981";
        button.style.color = "#FFFFFF";

        // Get updated cart content
        const cartContent = await (
          await fetch(`${window.Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];

        const items = responseJson.hasOwnProperty("items")
          ? responseJson["items"]
          : [responseJson];

        // Dispatch cart change event like the theme does
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          }),
        );

        // Show toast notification if theme supports it
        if (
          window.themeVariables &&
          window.themeVariables.settings.cartType === "message"
        ) {
          const message = window.themeVariables.strings.addedToCart
            ? window.themeVariables.strings.addedToCart.replace(
                "{{product_title}}",
                productTitle,
              )
            : `${productTitle} was added to your cart`;

          document.dispatchEvent(
            new CustomEvent("toast:show", {
              detail: { message: message },
            }),
          );
        }

        setTimeout(() => {
          button.textContent = originalText;
          button.style.background = "";
          button.style.borderColor = "";
          button.style.color = "";
          button.classList.remove("loading");
          button.classList.remove("is-loading");
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);

        // Try to get error message from response
        let errorMessage = "Error adding to cart";

        // Error feedback
        button.textContent = "✗";
        // button.style.background = "#EF4444";
        // button.style.borderColor = "#EF4444";
        button.style.color = "#FFFFFF";

        // Show error toast
        document.dispatchEvent(
          new CustomEvent("toast:show", {
            detail: {
              message: errorMessage,
              tone: "error",
            },
          }),
        );

        setTimeout(() => {
          button.textContent = originalText;
          button.style.background = "";
          button.style.borderColor = "";
          button.style.color = "";
          button.classList.remove("loading");
          button.classList.remove("is-loading");
        }, 2000);
      })
      .finally(() => {
        // End theme loading
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true }),
        );
      });
  }

  // Add event listeners to all quick add buttons
  function initializeQuickAddButtons() {
    const quickAddButtons = document.querySelectorAll(".quick-add__size-btn");

    quickAddButtons.forEach(function (button) {
      // Remove any existing event listeners
      button.removeEventListener("click", handleQuickAddClick);
      button.removeEventListener("mouseenter", handleDisabledHover);
      button.removeEventListener("mouseleave", handleDisabledHoverOut);

      // Add click event listener
      button.addEventListener("click", handleQuickAddClick);

      // Add hover event listeners for disabled buttons
      const isDisabled = button.classList.contains(
        "quick-add__size-btn--disabled",
      );
      if (isDisabled) {
        button.addEventListener("mouseenter", handleDisabledHover);
        button.addEventListener("mouseleave", handleDisabledHoverOut);
      }
    });
  }

  // Handle hover on disabled buttons to change label
  function handleDisabledHover(event) {
    const button = event.target;
    const quickAddContainer = button.closest(".product-card__quick-add");
    const label = quickAddContainer.querySelector(".quick-add__label");

    if (label) {
      if (quickAddContainer.dataset.discontinued === "true") {
        label.textContent = "Sold out";
      } else {
        label.textContent = "Join Waiting List";
      }
    }
  }

  // Handle hover out on disabled buttons to restore label
  function handleDisabledHoverOut(event) {
    const button = event.target;
    const quickAddContainer = button.closest(".product-card__quick-add");
    const label = quickAddContainer.querySelector(".quick-add__label");

    if (label) {
      label.textContent = "Quick add";
    }
  }

  // Handle quick add button click
  function handleQuickAddClick(event) {
    const button = event.target;
    const variantId = button.getAttribute("data-variant-id");
    const productTitle = button.getAttribute("data-product-title");
    const size = button.getAttribute("data-size");
    const available = button.getAttribute("data-available") === "true";

    if (button.classList.contains("quick-add__size-btn--disabled")) {
      return; // BIS handles it
    }
    if (!available) {
      return;
    }

    if (variantId && productTitle && size) {
      addToCartQuick(variantId, productTitle, size, button);
    }
  }

  // Initialize on page load
  initializeQuickAddButtons();

  // Re-initialize when new products are loaded (for infinite scroll, etc.)
  document.addEventListener("product-list:updated", function () {
    initializeQuickAddButtons();
  });

  // Also re-initialize after any dynamic content changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        // Check if any added nodes contain quick add buttons
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              node.classList &&
              node.classList.contains("quick-add__size-btn")
            ) {
              // This is a quick add button, initialize it
              node.removeEventListener("click", handleQuickAddClick);
              node.removeEventListener("mouseenter", handleDisabledHover);
              node.removeEventListener("mouseleave", handleDisabledHoverOut);

              node.addEventListener("click", handleQuickAddClick);

              // Add hover listeners if disabled
              const isDisabled = node.classList.contains(
                "quick-add__size-btn--disabled",
              );
              if (isDisabled) {
                node.addEventListener("mouseenter", handleDisabledHover);
                node.addEventListener("mouseleave", handleDisabledHoverOut);
              }
            } else if (
              node.querySelector &&
              node.querySelector(".quick-add__size-btn")
            ) {
              // This contains quick add buttons, initialize them
              const newButtons = node.querySelectorAll(".quick-add__size-btn");
              newButtons.forEach(function (newButton) {
                newButton.removeEventListener("click", handleQuickAddClick);
                newButton.removeEventListener(
                  "mouseenter",
                  handleDisabledHover,
                );
                newButton.removeEventListener(
                  "mouseleave",
                  handleDisabledHoverOut,
                );

                newButton.addEventListener("click", handleQuickAddClick);

                // Add hover listeners if disabled
                const isDisabled = newButton.classList.contains(
                  "quick-add__size-btn--disabled",
                );
                if (isDisabled) {
                  newButton.addEventListener("mouseenter", handleDisabledHover);
                  newButton.addEventListener(
                    "mouseleave",
                    handleDisabledHoverOut,
                  );
                }
              });
            }
          }
        });
      }
    });
  });

  // Start observing changes to the document
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  (function () {
    // --- GLOBAL OVERLAY ---
    let overlay = document.getElementById("cl-modal-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "cl-modal-overlay";
      overlay.className = "cl-modal-overlay";
      document.body.appendChild(overlay);
    }

    // Idempotent: several close paths (auto-timeout, close button, overlay
    // click) can fire for one open, and lockScroll is reference counted.
    const openOverlay = () => {
      if (overlay.classList.contains("active")) return;
      overlay.classList.add("active");
      lockScroll();
    };

    const closeOverlay = (unlock = true) => {
      if (!overlay.classList.contains("active")) return;
      overlay.classList.remove("active");
      if (unlock) unlockScroll();
    };

    function handleMobileBisSubmit(button) {
      const variantId = button.getAttribute("data-variant-id");
      const bisPopup = document.querySelector("cl-klaviyo-bis-popup");
      if (!bisPopup || !variantId) {
        console.warn("BIS popup not found or variant ID missing");
        return;
      }
      const emailEl = button.parentElement.querySelector(".cl-bis-email");
      if (!emailEl) return;
      const email = emailEl.value;

      if (!bisPopup.validateEmail(email)) {
        return;
      }

      bisPopup.postBackInStock({ email, variantId });

      button.closest(".cl-bis-mobile-content").style.display = "none";
      button
        .closest(".cl-bis-mobile-inline")
        .querySelector(".cl-success-msg").style.display = "block";
      emailEl.value = "";

      setTimeout(() => {
        // Reset form for next use
        button.closest(".cl-bis-mobile-content").style.display = "block";
        button
          .closest(".cl-bis-mobile-inline")
          .querySelector(".cl-success-msg").style.display = "none";
        button.closest(".cl-bis-mobile-inline").classList.remove("is-visible");

        const modal = button.closest(".cl-quick-add-modal.active");
        if (modal) {
          closeMobileQuickAddModal(modal);
        }
      }, 1800);
    }

    function closeMobileQuickAddModal(modal) {
      modal.classList.remove("active");
      closeOverlay();
      const parentSlider = modal.closest(".ccs-slider-container");
      if (parentSlider) {
        parentSlider.style.overflowX = "auto";
        parentSlider.style.overflowY = "";
      }
    }

    // --- Prevent background clicks ---
    overlay.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();

      // Only close if explicitly allowed
      if (overlay.dataset.closeOnOverlay === "true") {
        document
          .querySelectorAll(
            ".cl-quick-add-modal.active, #product-added-modal.active",
          )
          .forEach((m) => m.classList.remove("active"));
        closeOverlay();
      }
    });

    // --- Clear stale flags ---
    document
      .querySelectorAll("[data-quick-add-bound]")
      .forEach((el) => el.removeAttribute("data-quick-add-bound"));

    // --- Open Quick Add modal ---
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".cl-product-quick-add-button");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      // Close any open modals
      document
        .querySelectorAll(
          ".cl-quick-add-modal.active, #product-added-modal.active",
        )
        .forEach((m) => m.classList.remove("active"));

      // Open selected modal
      const productId = btn.dataset.productId;
      const modal = document.getElementById(`quick-add-modal-${productId}`);
      if (!modal)
        return console.warn("Quick add modal not found for", productId);

      // --- CLEAR PREVIOUS SIZE SELECTION ---
      const addBtn = modal.querySelector(".cl-quick-add-modal__add-btn");
      modal.querySelectorAll(".cl-quick-add-modal__size-btn").forEach((b) => {
        b.classList.remove("selected");
      });
      modal.dataset.selectedVariant = null;
      modal.dataset.selectedSize = "";

      modal.classList.add("active");

      openOverlay();
      const parentSlider = modal.closest(".ccs-slider-container");
      if (parentSlider) {
        parentSlider.style.overflowX = "hidden";
        parentSlider.style.overflowY = "hidden";
      }

      // --- Auto-select the first available size ---
      const firstAvailableSize = modal.querySelector(
        '.cl-quick-add-modal__size-btn[data-available="true"]',
      );
      if (firstAvailableSize) {
        firstAvailableSize.classList.add("selected");
        modal.dataset.selectedVariant = firstAvailableSize.dataset.variantId;
        modal.dataset.selectedSize = firstAvailableSize.textContent.trim();

        if (addBtn) {
          addBtn.style.display = "block";
          addBtn.disabled = false;
        }
      } else {
        // If no sizes are available, show the BIS inline
        modal
          .querySelector(".cl-quick-add-modal__size-btn:first-child")
          ?.classList.add("selected");
        const bisInline = modal.querySelector(".cl-bis-mobile-inline");
        if (bisInline) bisInline.classList.add("is-visible");
        if (addBtn) addBtn.style.display = "none";
      }
    });

    // --- Close Quick Add modal ---
    document.addEventListener("click", function (e) {
      const modal = e.target.closest(".cl-quick-add-modal.active");
      if (!modal) return;

      if (
        e.target.matches(".cl-modal-overlay") ||
        e.target.closest(".cl-quick-add-modal__close")
      ) {
        closeMobileQuickAddModal(modal);
      }
    });

    // --- Size selection ---
    document.addEventListener("click", function (e) {
      const sizeBtn = e.target.closest(".cl-quick-add-modal__size-btn");
      if (!sizeBtn) return;

      const modal = sizeBtn.closest(".cl-quick-add-modal");
      if (!modal) return;

      const bisInline = modal.querySelector(".cl-bis-mobile-inline");

      // Available size clicked → hide BIS inline
      if (bisInline) bisInline.classList.remove("is-visible");

      // --- Existing selection logic ---
      modal
        .querySelectorAll(".cl-quick-add-modal__size-btn")
        .forEach((b) => b.classList.remove("selected"));
      sizeBtn.classList.add("selected");
      modal.dataset.selectedVariant = sizeBtn.dataset.variantId;
      modal.dataset.selectedSize = sizeBtn.textContent.trim();
      const addBtn = modal.querySelector(".cl-quick-add-modal__add-btn");

      if (
        sizeBtn.classList.contains("cl-quick-add-modal__size-btn--disabled")
      ) {
        // Disabled size clicked → show BIS inline
        if (bisInline) {
          bisInline.classList.add("is-visible");
          bisInline
            .querySelector(".cl-bis-mobile-submit")
            .setAttribute("data-variant-id", sizeBtn.dataset.variantId);
        }
        if (addBtn) {
          addBtn.style.display = "none";
        }
      } else {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.style.display = "block";
        }
      }
    });

    // --- Add to cart ---
    document.addEventListener("click", function (e) {
      const addBtn = e.target.closest(".cl-quick-add-modal__add-btn");
      if (!addBtn) return;
      e.preventDefault();

      const modal = addBtn.closest(".cl-quick-add-modal");
      if (!modal || modal.classList.contains("adding")) return;
      modal.classList.add("adding");

      const variantId =
        modal.dataset.selectedVariant ||
        (modal.querySelector(".cl-quick-add-modal__size-btn.selected") || {})
          .dataset?.variantId;
      const productTitle =
        modal.dataset.productTitle ||
        modal.querySelector(".cl-quick-add-modal__title")?.textContent.trim() ||
        "";
      const productColor =
        modal.dataset.productColor ||
        modal.querySelector(".cl-quick-add-modal__color")?.textContent.trim() ||
        "";
      const size = modal.dataset.selectedSize || "";

      if (!variantId) {
        console.warn(
          "No variant selected in quick-add modal for",
          productTitle,
        );
        modal.classList.remove("adding");
        return;
      }

      const originalText = addBtn.textContent;
      addBtn.classList.add("loading");
      addBtn.disabled = true;

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        }),
      );

      if (sectionsToBundle.length > 0) {
        formData.append("sections", sectionsToBundle.join(","));
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:start", { bubbles: true }),
      );

      fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      })
        .then((r) => {
          if (!r.ok) throw new Error("Add to cart failed");
          return r.json();
        })
        .then(async (responseJson) => {
          const cartContent = await (
            await fetch(`${Shopify.routes.root}cart.js`)
          ).json();
          cartContent.sections = responseJson.sections;

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent,
                skipDrawerOpen: true,
              },
            }),
          );

          // --- Show Product Added Modal ---
          modal.classList.remove("active");

          // keep scroll locked while switching modals
          overlay.classList.add("active");

          const addedModal = document.getElementById("product-added-modal");
          if (addedModal) {
            addedModal.classList.add("active");

            const img = addedModal.querySelector(
              ".cl-product-added-modal__image",
            );
            const title = addedModal.querySelector(
              ".cl-product-added-modal__title",
            );
            const priceEl = addedModal.querySelector(
              ".cl-product-added-modal__price",
            );
            const colorEl = addedModal.querySelector(
              ".cl-product-added-modal__color",
            );
            const sizeEl = addedModal.querySelector(
              ".cl-product-added-modal__size",
            );

            const productImg =
              modal.querySelector(".cl-quick-add-modal__image")?.src || "";
            const productPrice =
              modal
                .querySelector(".cl-quick-add-modal__price")
                ?.textContent.trim() || "";

            if (img) img.src = productImg;
            if (title) title.textContent = productTitle || "Product added";
            if (priceEl) priceEl.textContent = productPrice;
            if (colorEl && productColor) colorEl.textContent = productColor;
            if (sizeEl && size) sizeEl.textContent = `Size: ${size}`;
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Could not add to cart — try again.");
        })
        .finally(() => {
          addBtn.classList.remove("loading");
          addBtn.disabled = false;
          addBtn.textContent = originalText;
          modal.classList.remove("adding");
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true }),
          );
        });
    });

    // --- Close "Product Added" Modal ---
    document.addEventListener("click", function (e) {
      const modal = document.getElementById("product-added-modal");
      if (!modal) return;

      if (
        e.target.closest(".cl-product-added-modal__close") ||
        e.target.closest(".cl-product-added-modal__continue-btn")
      ) {
        modal.classList.remove("active");
        closeOverlay();
        const parentSlider = modal.closest(".ccs-slider-container");
        if (parentSlider) {
          parentSlider.style.overflowX = "auto";
          parentSlider.style.overflowY = "";
        }
      }
    });

    // --- Handle mobile BIS submit ---
    document.addEventListener("click", function (e) {
      const bisSubmitBtn = e.target.closest(".cl-bis-mobile-submit");
      if (!bisSubmitBtn) return;

      handleMobileBisSubmit(bisSubmitBtn);
    });
  })();
});
